import $ from 'jquery';
import Inputmask from "inputmask";

export function inputMask() {
    const input = $('.tel');

    var im = new Inputmask({
        mask: "+38(999)999-99-99",
        'autoUnmask': true
    });
    im.mask(input);
}


// WEBPACK FOOTER //
// app/scripts/components/inputMask.js